import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxjarCategorySyncRunInfo } from '../fragments';

export default gql`
  mutation ActionSyncTaxjarCategories($input: TaxjarCategorySyncActionInput!) {
    actionTaxjarCategorySync(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      syncRun {
        ...TaxjarCategorySyncRunInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxjarCategorySyncRunInfo}
`;
